export default "__VITE_ASSET__DFqlG4No__"